import { createFileRoute } from "@tanstack/react-router"
import { AppointmentStatusPage } from "@/pages/appointment-status"

export const Route = createFileRoute("/(analytics)/appointment-confirmation")({
	component: AppointmentStatusPage,
})
